export enum RequestStatus {
  /// <summary>
  ///  İlk istek geldiğinde oluşturulduğu durum.
  /// </summary>
  Created = 0,

  /// <summary>
  ///  Coverage Control kontrolünden false aldığı durum.
  /// </summary>
  NotPool = 10,

  /// <summary>
  ///  Döküman gönderildikten sonra Dökümandan 0 gelmesi durumu.
  /// </summary>
  DocumentZeroValue = 20,

  /// <summary>
  ///  Turkish Technic tarafından istenilen PN yerine alternatif bir PN gönderme istediği yapıldığı zaman kullanılır.
  /// </summary>
  ///
  ReplacementPnOffered = 280,

  /// <summary>
  ///  Müşteri tarafından alternatif PNnin kabul edildiği durumdur.
  /// </summary>
  ///
  ReplacementPnAccepted = 170,

  /// <summary>
  ///  Müşteri tarafından alternatif PN red edildiği durumdur.
  /// </summary>
  ///
  ReplacementPnRejected = 180,

  /// <summary>
  ///  Dökümandan sıfır değeri geldikten sonra kabiliyet kontrolünden geçememe durumu.
  /// </summary>
  NoCapability = 250,

  /// <summary>
  ///  Dökümandan bir değeri geldikten sonra pool kullanıcısından onay almak üzere tekrardan coverage controle gönderildiği durum.
  /// </summary>
  ReturnManuelCoverageControl = 270,

  /// <summary>
  ///  Coverage Control kontrolünden true aldığı durum. Servisten zorunlu alanların gelmesini bekliyoruz.
  /// </summary>
  Pool = 50,

  /// <summary>
  ///  Nakliye detaylarının tamamının gönderilmediği durum.
  /// </summary>
  WaitingShippingDetails = 290,

  /// <summary>
  ///  Coverage Control kontrolünden true aldığı durum. Servisten tüm zorunlu alanların gönderildiği durum.
  /// </summary>
  SendShippingDetails = 60,

  /// <summary>
  ///  Uçağın yere indiği ve uçağın iniş bilgilerinin kaydedildiği durum.
  /// </summary>
  PlaneLanded = 70,

  /// <summary>
  ///  PLMS sistemindeki status değerinin uyuşmadığı durumdur.AAR'a mail gönderilerek döküman istenecek.Döküman gönderildiğinde Gümrük İşlemlerine geri gönderilecek.Statu yine 80'de kalacak.
  /// </summary>
  NotPlmsStatus = 80,

  /// <summary>
  ///  Pool userın dönen dökümana onay verdiği durum.
  /// </summary>
  PoolUserAccept = 90,

  /// <summary>
  ///  Pool userın dönen dökümana red verdiği durum. #KAPATILDI.
  /// </summary>
  PoolUserReject = 110,

  /// <summary>
  ///  Serviceable parça gönderimi sonrası müşteri parçayı kullanmadan ve kullanımdan kısa süre sonra geri göndermek istediğinde
  ///  UI tarafında istek yapabilir.
  /// </summary>
  ///
  RequestRedeliveryOffered = 400,

  /// <summary>
  ///  Müşteri tarafından yapılan istekler TT tarafından onaylanırsa.
  /// </summary>
  ///
  RequestRedeliveryAccepted = 410,
  /// <summary>
  ///  Müşteri tarafından yapılan istekler TT tarafından reddedilirse.
  /// </summary>
  ///
  RequestRedeliveryRejected = 420,

  /// <summary>
  ///  Traxa tanıtımın başarısız olduğu durum.
  /// </summary>
  ///
  NotInitialProcess = 100,

  /// <summary>
  ///  Karantina sürecinde dosya gönderildikten sonraki 2. dosya durumu
  /// </summary>
  ///
  NotInitialProcess2 = 101,

  /// <summary>
  ///  Traxa tanıtımın başarılı olduğu durum.
  /// </summary>
  ///
  InitialProcess = 120,

  /// <summary>
  ///  Request Delivery Date tarihinin gelmesine 3,4,5 gün kaldığı ve kullanıcının önüne seçilmesi için gösterileceği durum.
  /// </summary>
  ///
  OncomingDeliveryDate = 260,

  /// <summary>
  ///  Tamir sürecinin kullanıcı tarafından iptal edildiği durum.
  /// </summary>
  ///
  CancellationRepairPeriod = 160,

  /// <summary>
  ///  Capability ve Warranty kontrollerinden geçemediği durum.
  /// </summary>
  ///
  CapabilityWarrantyFailed = 130,

  /// <summary>
  ///  Warranty, Worscope, Vendor Process tamamlanmışsa.
  /// </summary>
  ///
  WarrantyWorkscopeVendorProcess = 140,

  /// <summary>
  ///  Capability ve Warranty kontrollerinden geçtiği durum.
  /// </summary>
  ///
  CapabilityWarrantyPassed = 150,
  /// <summary>
  ///  Alter Pn tüm componentlerin reddedilmesinden sonra aktif olan send to status 19 butonu ile geçtiği durum.
  /// </summary>
  ///
  Status19 = 190,
  Status22 = 220,
  Shipped = 230,
  Status24 = 240,
  Status30 = 300,
  /// <summary>
  ///  Alter Pn Offered.
  /// </summary>
  ///
  AlternatePnOffered = 310,
  /// <summary>
  ///  Alter Pn Accepted.
  /// </summary>
  ///
  AlternatePnAccepted = 320,
  /// <summary>
  ///  Alter Pn Rejected.
  /// </summary>
  ///
  AlternatePnRejected = 330,
  /// <summary>
  ///  Wo Category Abroad olduğu durum.
  /// </summary>
  ///
  ToBeKKm = 340,
  /// <summary>
  ///  Component Rezerv edildiğinde oluşan durum.
  /// </summary>
  ///
  Reserved = 350,

  CancelledRequest = 440,

  OpenNotSet = 1000,
  InProgress = 2000,
  WaitingTTApproval = 3000,
  Rejected = 4000,

  ServiceableAccepted = 5000,
  ServicebleRejected = 6000,
}
